// this is the component that displays the progress of loading assets for the current level

class LoadingContainer {
    element = document.querySelector('#loading-container') as HTMLDivElement
    progressElement = this.element.querySelector('#loading-progress__progress-indicator') as HTMLDivElement
    startButton = this.element.querySelector('#start-button') as HTMLDivElement
    progressButton = this.element.querySelector('#progress-button') as HTMLDivElement
    progressPercent = this.element.querySelector('#progress-button__percent') as HTMLDivElement

    setProgress = (value: number) => {
        this.progressElement.style.setProperty('width', `${value}%`)
        this.progressPercent.innerHTML = `${value}%`
    }

    resetProgress = () => {
        this.progressElement.style.setProperty('width', '0%')
        this.progressPercent.innerHTML = '0%'
    }

    show = () => {
        this.element.classList.remove('hidden')
        this.showProgressButton()
    }

    hide = () => {
        this.element.classList.add('hidden')
    }

    showStartButton = () => {
        this.startButton.classList.remove('hidden')
    }

    hideStartButton = () => {
        this.startButton.classList.add('hidden')
    }

    showProgressButton = () => {
        this.progressButton.classList.remove('hidden')
    }

    hideProgressButton = () => {
        this.progressButton.classList.add('hidden')
    }

    clickStart = () =>
        new Promise((resolve) => {
            this.hideProgressButton()
            this.showStartButton()
            this.startButton.addEventListener('click', resolve, { once: true })
        }).then(() => {
            this.hideStartButton()
        })
}

export default new LoadingContainer()
